import { Document, Page, Text, View, StyleSheet} from '@react-pdf/renderer';

import {style} from '../../components/pdf/fontstyles';
import {AutoText} from '../../components/pdf/autoText'; 




const styles = StyleSheet.create({
      
          table: {
            
            display: 'table',
            width: '100%',
            borderStyle: 'solid',
            borderWidth: 1,
            borderColor: '#000',
            marginTop: 0,
          },
          row: {
            flexDirection: 'row',
            borderBottom: '1px solid #000',
          },
          cell: {
            padding: 5,
            borderRight: '1px solid #000',
            verticalAlign: 'middle',
          },
          headerCell: {
            fontWeight: 'bold',
            backgroundColor: '#f2f2f2',
          },
          // Column specific styles (adjust widths for each column)
          srNoCell: {
            width: '30%', 
          },
          relation: {
            width: '10%', 
          },
          age: {
            width: '10%', 
          },
          amtgrad: {
            width: '10%', 
          },
          address: {
            width: '30%', 
          },
          amtpayable: {
            width: '10%', 
          },

          srno: {
            width: '15%',
          },
          Name: {
            width: '50%',
          },
          Signature: {
            width: '35%',
          },

          bulletRow: {
            flexDirection: 'row',
            alignItems: 'flex-start',
            marginBottom: 6, 
          },
          bulletSymbol: {
            width: 10,
            fontSize: 10,
            marginRight: 5, 
          },
          bulletText: {
            flex: 1,
            fontSize: 10,
            textAlign: 'justify',
            lineHeight: 1.5,
          },
        

        });


        
        
const AppendixV = ({ result }) => {
  const [rd, rm, ry] = result.dateOfRetirement.split('/').map(Number);
  const [bd, bm, by] = result.spouseDOB.split('/').map(Number);
  
  let spouseAge = ry - by;
  if (rm < bm || (rm === bm && rd < bd)) spouseAge--;
  
   const tableData = [
  ['1', '2', '3', '4', '5', '6'],
  ...(
    result.childDetails?.length === 1
      ? [
          [`${result.spouseName}, ${result.address}`, result.spouceRelation, spouseAge, '100%', result.childDetails[0].nameChild, '100%'],
        ]
      : result.childDetails?.length === 2
      ? [
          [`${result.spouseName}, ${result.address}`, result.spouceRelation, spouseAge, '100%', result.childDetails[0].nameChild, '50%'],
          ['', '', '', '', result.childDetails[1].nameChild, '50%'],
        ]
      : []
  ),
];

      const table2 = [
        ['1', '', ''],
        ['2', '', ''],
      ];      
  
  return (
              <View size="A4" style={style.page}> 
                <Text style={[style.title, style.ArialBlack , {fontSize: 10, textAlign: 'left'}]}>APPENDIX -V</Text>
                <Text style={[style.title, style.ArialBlack]}>Form 1</Text>
                <Text style={[style.subtitle, style.ArialItalic]}>[see rule 115(1)]</Text>
                <Text style={[style.title ,style.ArialBold ]}>Nomination for Death-Cum -Retirement Gratuity</Text>
            <View style={style.solidLine} />
                <Text style={[style.subtitle]}>When the Government servant has a family and wishes to nominate one member or more than one member thereof.</Text>

                <AutoText style={[style.paragraph]}>I, {result.employeeName} hereby nominate the persosn /persons mentioned below who is /are member(s) of my family, and confer on him/them right to receive, to the extent specified below any gratuity that may be sanctioned by the Government of Maharashtra in the event of my death while in service & the right to receive on my death, to the extent specified below any gratuity which having become admissible to me on retirement may remain unpaid at my death.-</AutoText>



               {/* Table */}
                   <View style={styles.table}>

                          {/* Header Row */}
                          <View style={[styles.row, styles.headerCell]}>
                            <Text style={[styles.cell, styles.srNoCell]}>Name(s) and address(es) of nominee/ nominees</Text>
                            <Text style={[styles.cell, styles.relation]}>Relationship with the Govt. servant</Text>
                            <Text style={[styles.cell, styles.age]}>Age in years</Text>
                            <Text style={[styles.cell, styles.amtgrad]}>Amount or share of gratuity payable to each (*)</Text>
                            <Text style={[styles.cell, styles.address]}>Name address, relationship and age of the paersons, if any, to whom the right conferred on the nominee shall pass in the event of the nominee predeceasing the Govt. servant or the nominee dying after the death of the Govt. servant but before receiving payment of gratuity.</Text>
                            <Text style={[styles.cell, styles.amtpayable]}>Amount or share of gratuity payable (**)</Text>
                          </View>

                    
                     {/* Table Data */}
                     {tableData.map(([name, relation, age, amtgrad, address, amtpayable], index) => (
                      <View style={styles.row} key={index}>
                        <Text style={[styles.cell, styles.srNoCell]}>{name}</Text>
                        <Text style={[styles.cell, styles.relation]}>{relation}</Text>
                        <Text style={[styles.cell, styles.age]}>{age}</Text>
                        <Text style={[styles.cell, styles.amtgrad]}>{amtgrad}</Text>
                        <Text style={[styles.cell, styles.address]}>{address}</Text>
                        <Text style={[styles.cell, styles.amtpayable]}>{amtpayable}</Text>
                      </View>
                    ))}
              </View>
              <Text style={[style.paragraph, {fontSize: 8, marginBottom: 0}]}>*  The column should be filled in so as to  cover the whole amount of the gratuity.</Text>
              <Text style={[style.paragraph, {fontSize: 8, marginTop: 1, marginBottom: 0}]}>**  The amount /share of the gratuity shown in this should cover the whole amount /share payable to the original nominee(s) -</Text>

              <Text style={[style.paragraph,{marginBottom: 0}]}>This Nomination supersedes the Nomination made by me earlier on __________ which stands cancelled.</Text>
              <Text style={[style.paragraph, {marginTop: 2}]}>Date this ______________ day of  ______________ at {result.placeOfRetirement}</Text>

               <View style={[styles.bulletRow, { marginTop: 5 }]}>     
                <Text style={[style.paragraph]}>Witness</Text>
                  <Text style={[style.signature, {textAlign: 'right'}]}>{result.employeeName}</Text>
                </View>
                        {/* Table */}
                   <View style={styles.table}>

                  {/* Header Row */}
                  <View style={[styles.row, styles.headerCell]}>
                    <Text style={[styles.cell, styles.srno]}>Sr. No</Text>
                    <Text style={[styles.cell, styles.Name]}>Name </Text>
                    <Text style={[styles.cell, styles.Signature]}>Signature</Text>
                  </View>


                  {/* Table Data */}
                  {table2.map(([name, relation, age], index) => (
                  <View style={styles.row} key={index}>
                  <Text style={[styles.cell, styles.srno]}>{name}</Text>
                  <Text style={[styles.cell, styles.Name]}>{relation}</Text>
                  <Text style={[styles.cell, styles.Signature]}>{age}</Text>
                  </View>
                  ))}
                  </View>

    
                <Text style={[style.subtitle, { marginTop: 10 }]}>( To be filled by the Head of Office/ Audit Officer)</Text>

                <Text style={[style.signature]}>Head of Office</Text>
                <Text style={[style.paragraph, { marginTop: 10 }]}>Nomination by:</Text>
              </View>

);
};

export default AppendixV;